import { RootState } from '../../store';

export const getManualVerificationStepperActiveStep = (state: RootState) =>
  state.manualVerificationStepperDetails.activeStep;
export const getManualVerificationStepperActiveBackAction = (state: RootState) =>
  state.manualVerificationStepperDetails.backAction;
export const getManualVerificationSelectedProvierId = (state: RootState) =>
  state.manualVerificationStepperDetails.selectedProviderId;
export const getManualVerificationSelectedSessionId = (state: RootState) =>
  state.manualVerificationStepperDetails.selectedSessionId;
export const getManualVerificationSelectedAppId = (state: RootState) =>
  state.manualVerificationStepperDetails.selectedAppId;
